module.exports = __webpack_public_path__ + "static/UNITY-Tower-lower-floor-4-tenants_v2-9c6cff40dd3186f0e90d0e8d3c64f757.pdf";